import { Selector } from 'reselect';
import { Fund } from 'src/components/Exchange/types';
import { FederalTaxPercent } from 'src/settings/settings';
import { Action } from 'typesafe-actions';
import { ApplicationDataState } from './applicationData/types';
import { AutoExchangeState } from './autoExchange/types';
import { AutomaticInvestmentsState } from './automaticInvestments/types';
import { BankSelectionState } from './bankSelection/types';
import { CostBasisTransactionState } from './costBasis/types';
import { EditModeBankState } from './editModeBank/types';
import { ExchangeTransaction } from './exchangeTransaction/types';
import { ExecuteAutoExchangeTransaction } from './executeAutoExchange/types';
import { ExecuteExchangeState } from './executeExchange/types';
import { ExecuteRedemptionState } from './executeRedemption/types';
import { ExistingBanksState } from './existingBanks/types';
import { AllFundsState } from './funds/AllFunds/types';
import { IRALimitState } from './funds/IRA/types';
import { UserFundsState } from './funds/UserFunds/types';
import { IRAAutoMaxFundsState } from './funds/IRAAutoMaxFunds/types';
import { IRAAutoMaxCartDetailsState } from './funds/IRAAutoMaxCartDetails';
import { PendingTransactionsState } from './pendingTransactions/types';
import { ProgressState } from './progress/types';
import { SellDeliveryMethodState } from './sellDeliveryMethod/types';
import { SellTransactionState } from './sellTransaction/types';
import { SellUncollectedSharesState } from './sellUncollectedShares/types';
import { ShoppingCartState } from './shoppingCart/types';
import { StateWithholdingState } from './stateWithholding/types';
import { TransactionLimitState } from './transactionLimits/types';
import { PersonalInformationState } from './user/PersonalInformation/types';
import { RothConversionState } from './rothConversionTransaction/types';
import { ExecuteRothConversionState } from './executeRothConversion/types';
import { ExistingSchoolsState } from './addSchool/types';
import { SchoolSelectionState } from './schoolSelection';
import { StudentDetailState } from './studentDetail';
import { IRAAutoMaxCalculationState } from './funds/IRAAutoMaxCalculation';
import { IRAAutoMaxSubmissionState } from './funds/IRAAutoMaxSubmission';

export interface AbstractTransaction {
  isLoading: boolean;
  isLoaded: boolean;
  loading: boolean;
  hasFailed: boolean;
  error?;
  validationFailed: boolean;
}
export interface ApplicationState {
  allFunds: AllFundsState;
  applicationData: ApplicationDataState;
  autoExchange: AutoExchangeState;
  automaticInvestments: AutomaticInvestmentsState;
  bankSelection: BankSelectionState;
  costBasis: CostBasisTransactionState;
  editModeBank: EditModeBankState;
  exchangeTransaction: ExchangeTransaction;
  executeAutoExchange: ExecuteAutoExchangeTransaction;
  executeExchange: ExecuteExchangeState;
  executeRedemption: ExecuteRedemptionState;
  existingBanks: ExistingBanksState;
  IRALimit: IRALimitState;
  paperlessSetting;
  pendingTransactions: PendingTransactionsState;
  personalInformation: PersonalInformationState;
  progress: ProgressState;
  rothConversionTransaction: RothConversionState;
  executeRothConversionTransaction: ExecuteRothConversionState;
  sellDeliveryMethod: SellDeliveryMethodState;
  sellTransaction: SellTransactionState;
  sellUncollectedShares: SellUncollectedSharesState;
  shoppingCart: ShoppingCartState;
  stateWithholding: StateWithholdingState;
  transactionLimits: TransactionLimitState;
  userFunds: UserFundsState;
  iraAutoMaxFunds: IRAAutoMaxFundsState;
  iraAutoMaxCartDetails: IRAAutoMaxCartDetailsState;
  iraAutoMaxCalculation: IRAAutoMaxCalculationState;
  iraAutoMaxSubmission: IRAAutoMaxSubmissionState;
  schools: ExistingSchoolsState;
  schoolSelection: SchoolSelectionState;
  studentDetail: StudentDetailState;
}
/** @deprecated */
export type GetSubstate = <T, R>(key: string) => Selector<T, R>;

/** @deprecated */
export const getSubState: GetSubstate = (key) => (state) => state[key];

/** @deprecated */
export interface StrictModuleActions {
  openModal(type: string, payload?): void;
  updateExchangeFederalWithholding(b: boolean, tax: FederalTaxPercent): void;
  selectExchangeFromFund(a: Fund['agreementID']): void;
}

export type ModuleActions = StrictModuleActions &
  Record<string, (p?: unknown) => void | Action>;
